export const totalingData = [
  {
    principal: "$10,000",
    interestPayment: "$2,748.23",
    loanPayment: "$12,748.23",
    payoffDate: "10 / 2029",
    monthlyPayment: "$212.47",
    originationFee: "$500.00",
    costOfLoan: "$3,248.23",
    apr: "12.13%",
  },
];

export const amortizationHeader = [
  {
    head: "Payment Date",
  },
  {
    head: "Principal",
  },
  {
    head: "Interest",
  },
  {
    head: "Monthly Total",
  },
  {
    head: "Principal Balance",
  },
];

export const amortizationData = [
  {
    id: 1,
    paymentDate: "Oct 2024",
    principal: "$129.14",
    interest: "$83.33",
    monthlyTotal: "$212.47",
    principalBalance: "$9,870.86",
  },
  {
    id: 2,
    paymentDate: "Nov 2024",
    principal: "$130.21",
    interest: "$82.26",
    monthlyTotal: "$212.47",
    principalBalance: "$9,740.65",
  },
  {
    id: 3,
    paymentDate: "Dec 2024",
    principal: "$131.30",
    interest: "$81.17",
    monthlyTotal: "$212.47",
    principalBalance: "$9,609.35",
  },
  {
    id: 4,
    paymentDate: "Jan 2025",
    principal: "$132.39	",
    interest: "$80.08",
    monthlyTotal: "$212.47",
    principalBalance: "$9,343.46",
  },
  {
    id: 5,
    paymentDate: "Feb 2025",
    principal: "$129.14",
    interest: "$83.33",
    monthlyTotal: "$212.47",
    principalBalance: "$9,870.86",
  },
  {
    id: 6,
    paymentDate: "Mar 2025",
    principal: "$134.61",
    interest: "$77.86",
    monthlyTotal: "$212.47",
    principalBalance: "$9,208.85",
  },
  {
    id: 7,
    paymentDate: "Apr 2025",
    principal: "$135.73",
    interest: "$76.74",
    monthlyTotal: "$212.47",
    principalBalance: "$9,073.12",
  },
  {
    id: 8,
    paymentDate: "May 2025",
    principal: "$136.86",
    interest: "$75.61",
    monthlyTotal: "$212.47",
    principalBalance: "$8,936.26",
  },
  {
    id: 9,
    paymentDate: "June 2025",
    principal: "$129.14",
    interest: "$83.33",
    monthlyTotal: "$212.47",
    principalBalance: "$9,870.86",
  },
  {
    id: 10,
    paymentDate: "Jul 2025",
    principal: "$138.00",
    interest: "$212.47",
    monthlyTotal: "$212.47",
    principalBalance: "$8,798.26",
  },
  {
    id: 11,
    paymentDate: "Aug 2025",
    principal: "$129.14",
    interest: "$83.33",
    monthlyTotal: "$212.47",
    principalBalance: "$9,870.86",
  },
  {
    id: 12,
    paymentDate: "Sep 2025",
    principal: "$129.14",
    interest: "$83.33",
    monthlyTotal: "$212.47",
    principalBalance: "$9,870.86",
  },
  {
    id: 13,
    paymentDate: "Oct 2025",
    principal: "$129.14",
    interest: "$83.33",
    monthlyTotal: "$212.47",
    principalBalance: "$9,870.86",
  },
  {
    id: 14,
    paymentDate: "Nov 2025",
    principal: "$129.14",
    interest: "$83.33",
    monthlyTotal: "$212.47",
    principalBalance: "$9,870.86",
  },
  {
    id: 15,
    paymentDate: "Dec 2025",
    principal: "$129.14",
    interest: "$83.33",
    monthlyTotal: "$212.47",
    principalBalance: "$9,870.86",
  },
  {
    id: 16,
    paymentDate: "Jan 2026",
    principal: "$129.14",
    interest: "$83.33",
    monthlyTotal: "$212.47",
    principalBalance: "$9,870.86",
  },
  {
    id: 17,
    paymentDate: "Feb 2026",
    principal: "$129.14",
    interest: "$83.33",
    monthlyTotal: "$212.47",
    principalBalance: "$9,870.86",
  },
  {
    id: 18,
    paymentDate: "Mar 2026",
    principal: "$129.14",
    interest: "$83.33",
    monthlyTotal: "$212.47",
    principalBalance: "$9,870.86",
  },
  {
    id: 19,
    paymentDate: "Apr 2026",
    principal: "$129.14",
    interest: "$83.33",
    monthlyTotal: "$212.47",
    principalBalance: "$9,870.86",
  },
  {
    id: 20,
    paymentDate: "May 2026",
    principal: "$129.14",
    interest: "$83.33",
    monthlyTotal: "$212.47",
    principalBalance: "$9,870.86",
  },
];
